import React, { FC, ReactNode, useEffect, useRef, useState } from "react";
import styles from "./filter.module.scss";
import { FilterIcon, InfoIcon } from "../svg-components";
import { colors } from "../../../constants/color";
import { t } from "i18next";

interface IFilterProps {
  title: string;
  children: ReactNode;
  customClassChild?: any;
  customClass?: any;
  showChildren?: boolean;
  setShowChildren?: any;
}

const Filter: FC<IFilterProps> = ({
  children,
  customClassChild,
  title,
  customClass,
  showChildren = true,
  setShowChildren,
}) => {
  const [show, setShow] = useState<boolean>(false);
  const ref = useRef<any>();
  useEffect(() => {
    const checkIfClickedOutside = (e: any) => {
      if (show && ref.current && !ref.current.contains(e.target)) {
        setShow(false);
        if (setShowChildren) {
          setShowChildren(false);
        }
      }
    };
    document.addEventListener("mousedown", checkIfClickedOutside);
    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [show]);

  useEffect(() => {
    if (!showChildren) {
      setShow(false);
    }
  }, [showChildren]);

  return (
    <div className={[styles.filterContainer, customClass].join(" ")} ref={ref}>
      <span>
        <FilterIcon
          fillColor={colors.grey2}
          handleClick={() => {
            setShow(!show);
            if (setShowChildren) {
              setShowChildren(true);
            }
          }}
        />
      </span>
      {show && showChildren && (
        <div className={[styles.filterChildren, customClassChild].join(" ")}>
          <span className={styles.infoTitle}>{title}</span>
          {children}
        </div>
      )}
    </div>
  );
};

export default Filter;
